module.exports = __webpack_public_path__ + "img/6.78063e07.png";